module.exports = __webpack_public_path__ + "media/images/img_rounge_6-c4ea9fd4a83491c30c4af306bf191369.jpg";